import React from "react";
import { Box, Grid } from "@mui/material";
import { useGetReviews } from "hooks/queries/useGetReviews";
// import { useNavigate } from "react-router-dom";
import UserGoalCard from "./UserGoalCard";
import { useGetGoals } from "hooks/queries/useGetGoals";
import GoalTable from "components/GoalSetting/GoalTable";

const UserGoal = () => {
  const { reviews } = useGetReviews();
  const {goals} = useGetGoals();

  //   const navigate = useNavigate();

  //   const handleEvaluate = (id: string) => {
  //     navigate(`/evaluation/${id}`);
  //   };

  return (
    <Box display="flex" flexDirection="column">
      <Grid container spacing={2} sx={{ marginBottom: "50px" }}>
        {reviews?.map((review) => (
          <Grid item xs={12} md={3}>
            <UserGoalCard review={review} />
          </Grid>
        ))}

      </Grid>
        {/* <GoalTable   /> */}
    </Box>
  );
};

export default UserGoal;
